import React from "react";
import "./overlaySection.css";

const OverlaySection = ({ data }) => {
    const { imageUrl, text, highlight } = data;
    return (
        <section
            className="overlay-section"
            style={{ backgroundImage: `url(${imageUrl})` }}
        >
            <div className="overlay-box">
                <p className="overlay-text">
                    {text}{" "}
                    <span className="overlay-highlight">
                        {highlight}
                    </span>
                </p>
            </div>
        </section>
    );
};

export default OverlaySection;
